import type { ButtonProps } from "@chakra-ui/react";
import { Link as BPLink } from "components/Link";
import type { BannerCTA } from "types/cms";
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils";
import { cmsPageClick } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils";
import React from "react";
import { DeprecatedChakraButton } from "./Button";

type Props = BannerCTA &
  CMSPageProps & {
    customOnClickHandler?: (e) => void;
    buttonProps?: ButtonProps;
  };

export const LinkCta: React.FC<Props> = ({
  trackingModule,
  title,
  link,
  backgroundColor,
  buttonProps = {},
  customOnClickHandler,
  isPrimaryStyle
}) => {
  const handleClick = () => {
    cmsPageClick({
      ...trackingModule,
      moduleContentUrl: link,
      moduleContentDetails: "cta_clicked"
    });
  };

  const clickHandler = customOnClickHandler ?? handleClick;

  return (
    <BPLink title={title} href={link}>
      <DeprecatedChakraButton
        trackingModule={trackingModule}
        isLoading={false}
        title={title}
        link=""
        backgroundColor={backgroundColor}
        buttonProps={buttonProps}
        isPrimaryStyle={isPrimaryStyle}
        customOnClickHandler={clickHandler}
      />
    </BPLink>
  );
};
